import { render } from "./SectionHeader.vue?vue&type=template&id=b8a01e4a&ts=true"
import script from "./SectionHeader.vue?vue&type=script&lang=ts"
export * from "./SectionHeader.vue?vue&type=script&lang=ts"

import "./SectionHeader.vue?vue&type=style&index=0&id=b8a01e4a&lang=scss"

import exportComponent from "/home/runner/work/billygrossman.com/billygrossman.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__